import React, { useState } from 'react';
import { Tooltip } from 'antd';
import { useTaskDrawer } from '../TaskDrawerContext';

export default function TaskDescription() {
    const {
        editDescription,
        setEditDescription,
        improvingDescription,
        preImproveDescription,
        handleImproveDescription,
        handleUndoImproveDescription,
    } = useTaskDrawer();

    const [isEditing, setIsEditing] = useState(false);

    return (
        <section className="space-y-2 px-1">
            <div className="flex justify-between items-center">
                <h3 className="text-[13px] font-bold text-[#111827] dark:text-white">Description</h3>

                <div className="flex items-center gap-2">
                    {/* Undo button — only visible after AI has improved the description */}
                    {preImproveDescription !== null && (
                        <Tooltip title="Undo AI improvement">
                            <button
                                onClick={handleUndoImproveDescription}
                                className="flex items-center gap-1 text-ed-on-surface-variant text-xs hover:text-error transition-all"
                            >
                                <span className="material-symbols-outlined text-sm">undo</span>
                                Undo
                            </button>
                        </Tooltip>
                    )}

                    {/* Enhance with AI button */}
                    <button
                        onClick={handleImproveDescription}
                        disabled={improvingDescription || !editDescription?.trim()}
                        className="flex items-center gap-1.5 text-primary font-medium text-xs hover:underline transition-all disabled:opacity-40 disabled:cursor-not-allowed"
                    >
                        {improvingDescription ? (
                            <>
                                <span className="material-symbols-outlined text-sm animate-spin">progress_activity</span>
                                Enhancing…
                            </>
                        ) : (
                            <>
                                <span className="material-symbols-outlined text-sm">auto_awesome</span>
                                Enhance with AI
                            </>
                        )}
                    </button>
                </div>
            </div>

            {isEditing ? (
                <textarea
                    value={editDescription}
                    onChange={(event) => setEditDescription(event.target.value)}
                    onBlur={() => setIsEditing(false)}
                    placeholder="Add a description…"
                    rows={5}
                    autoFocus
                    className="w-full text-[13px] text-[#374151] dark:text-white bg-white dark:bg-[#141414] border border-[#e5e7eb] dark:border-[#303030] rounded-xl p-3 focus:outline-none focus:ring-2 focus:ring-[#03488a]/20 transition-all resize-none leading-relaxed"
                />
            ) : (
                <div
                    onClick={() => setIsEditing(true)}
                    className="text-[13px] leading-relaxed text-[#374151] dark:text-[#e2e8f0] cursor-text min-h-[72px] hover:bg-[#f8f9fa] dark:hover:bg-[#262626] rounded-lg px-2 py-1.5 transition-colors -mx-2"
                >
                    {editDescription ? (
                        editDescription.trim().startsWith('<') ? (
                            <div
                                className="prose prose-sm max-w-none dark:prose-invert"
                                dangerouslySetInnerHTML={{ __html: editDescription }}
                            />
                        ) : (
                            <p className="whitespace-pre-wrap">{editDescription}</p>
                        )
                    ) : (
                        <p className="text-[#9ca3af] dark:text-slate-500 italic">Click to add a description…</p>
                    )}
                </div>
            )}
        </section>
    );
}
